import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { getParticipantCountForDisplay } from '../../../base/participants/functions';
const useStyles = makeStyles()(theme => {
    return {
        badge: {
            backgroundColor: '#4A5568',
            borderRadius: '100%',
            height: '16px',
            minWidth: '16px',
            color: 'white',
            fontSize: '0.625rem',
            fontWeight: 700,
            pointerEvents: 'none',
            position: 'absolute',
            right: '-4px',
            top: '-3px',
            textAlign: 'center',
            padding: '1px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: '1'
        }
    };
});
const ParticipantsCounter = () => {
    const { classes } = useStyles();
    const participantsCount = useSelector(getParticipantCountForDisplay);
    return React.createElement("span", { className: classes.badge }, participantsCount);
};
export default ParticipantsCounter;
